import { Link } from 'react-router-dom';
import { ThemeBackdrop } from '../lib/themeEmblem';
import { useTheme } from '../lib/useTheme';

export default function About() {
  const theme = useTheme();

  return (
    <main className="relative isolate min-h-screen">
      <ThemeBackdrop theme={theme} />
      <article className="relative z-10 mx-auto w-full max-w-4xl px-6 pb-24 pt-24 sm:pt-28">
        <Link to="/" className="text-sm text-muted hover:text-fg">← 返回首頁</Link>
        <p className="mt-14 font-mono text-[0.65rem] uppercase tracking-[0.22em] text-accent">
          About Tarot Chat
        </p>
        <h1 className="mt-4 max-w-3xl font-display text-4xl leading-tight text-heading sm:text-6xl">
          把占卜體驗做成可展示、可收費、可代管的線上流程。
        </h1>
        <div className="mt-10 grid gap-5 md:grid-cols-3">
          {[
            ['前端體驗', '三種風格不只換色，而是在牌桌、聊天、進度與互動節奏上分流。'],
            ['合規告知', '開始前明確告知 AI 輔助、資料處理、跨境與非醫療/法律建議界線。'],
            ['商業模型', '免費短解讀建立投入感，完整報告與後續服務承接付費轉換。'],
          ].map(([title, body]) => (
            <section
              key={title}
              className="border bg-elevated/78 p-5 backdrop-blur-xl"
              style={{ borderColor: 'var(--color-border)', borderRadius: 'var(--radius-card)' }}
            >
              <h2 className="font-display text-2xl text-heading">{title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-muted">{body}</p>
            </section>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/pricing"
            className="px-5 py-3 text-sm font-semibold"
            style={{ background: 'var(--btn-bg)', color: 'var(--btn-ink)', borderRadius: 'var(--radius-pill)' }}
          >
            查看價格
          </Link>
          <Link
            to="/lab"
            className="border px-5 py-3 text-sm font-semibold text-fg"
            style={{ borderColor: 'var(--color-border)', borderRadius: 'var(--radius-pill)' }}
          >
            進入 Lab
          </Link>
        </div>
      </article>
    </main>
  );
}
